import { useState, useEffect } from 'react'

interface HeaderState {
  scrolled: boolean
  hidden: boolean
}

const SCROLL_THRESHOLD = 16
const HIDE_THRESHOLD = 300

export function useHeaderState(): HeaderState {
  const [scrolled, setScrolled] = useState(false)
  const [hidden, setHidden] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    let ticking = false

    const onScroll = () => {
      if (ticking) return
      ticking = true

      requestAnimationFrame(() => {
        const currentY = window.scrollY

        setScrolled(currentY > SCROLL_THRESHOLD)

        if (currentY > HIDE_THRESHOLD) {
          setHidden(currentY > lastScrollY)
        } else {
          setHidden(false)
        }

        setLastScrollY(currentY)
        ticking = false
      })
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [lastScrollY])

  return { scrolled, hidden }
}
